function logError(activity, isHandlerError, data) {

    activity = activity + " " + ((isHandlerError) ? "Error Handler" : "Error");

    //Only log if you have initialized the activity log using the log entries token
    if (typeof LE !== "undefined" && typeof activity !== "undefined" && activity !== null && activity !== "") {

        var d = new Date();
        var date = d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1).pad("0", 2) + "-" + d.getUTCDate().pad("0", 2);
        var time = d.getUTCHours().pad("0", 2) + ":" + d.getUTCMinutes().pad("0", 2) + ":" + d.getUTCSeconds().pad("0", 2);
        date = date + " " + time;
        
        var accountId = "NULL";
        var userId = "NULL";
        var tierName = "NULL";
        var computerId = "NULL";

        if (typeof cccApp !== "undefined") {
            accountId = (cccApp.account) ? cccApp.account.id : accountId;
            userId = (cccApp.user) ? cccApp.user.id : userId;
            tierName = (cccApp.tier) ? cccApp.tier.description.split(" ").join("_") : tierName;
            computerId = (cccApp.computer) ? cccApp.computer.guid() : computerId;
        }

        activity = activity.split(" ").join("_");

        var logString = date + " " + accountId + " " + userId + " " + tierName + " " + computerId + " " + activity ;

        if (typeof data === "object") {
            logString += " '";
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    if (data[key]) {
                        var attrValue;
                        if (typeof data[key] === "object") {
                            attrValue = key + ": " + JSON.stringify(data[key]);
                        } else {
                            attrValue = data[key].toString();
                        }
                        
                        logString += " " + attrValue;
                    }
                }
            }
            logString += "'";
        }

        logString = " " + logString + " ";

        try {
            if (LE.to("handled")) {
                LE.to("handled").log(logString);
            }
        } catch (e) {

        }
    }
}

function logRequireError(activity, isHandlerError, errorMessage, messagePlaceholder, error, data) {

    if (!error) {
        error = { message: "Unknown Require Error" };
    }

    if (cccApp && cccApp.settings && cccApp.settings.isDebugMode) {
        if (console && console.error) {
            console.error(error);
        }
    }

    if (cccApp && cccApp.msg && errorMessage && messagePlaceholder) {
        cccApp.msg.error(errorMessage, messagePlaceholder);
    }

    var errorData = {
        message: error.message,
        type: error.requireType,
        modules: error.requireModules
    };

    if (data && typeof data === "object") {
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                errorData[prop] = data[prop];
            }
        }
    }

    logError(activity, isHandlerError, errorData);
}

function logActivity(activity, data) {

    //Intercom
    if (typeof Intercom !== "undefined") {
        Intercom("trackEvent", activity);
    }

    //Only log if you have initialized the activity log using the log entries token
    if (typeof LE !== "undefined" && typeof activity !== "undefined" && activity !== null && activity !== "") {

        var d = new Date();
        var date = d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2) + " " + ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getUTCSeconds()).slice(-2);

        var accountId = "NULL";
        var userId = "NULL";
        var tierName = "NULL";
        var computerId = "NULL";
        var activityId = -1;

        var matchingActivity = jQuery.grep(activityTypes, function (n) {
            return (n[1] === activity);
        });


        if (matchingActivity && matchingActivity.length > 0) {
            activityId = matchingActivity[0][0];
        }

        if (typeof cccApp !== "undefined" && cccApp) {
            accountId = (cccApp.account) ? cccApp.account.id : accountId;
            userId = (cccApp.user) ? cccApp.user.id : userId;
            tierName = (cccApp.tier) ? cccApp.tier.description.split(" ").join("_") : tierName;
            computerId = (cccApp.computer) ? cccApp.computer.guid() : computerId;
        }

        activity = activity.split(" ").join("_");

        var logString = "d=" + date + " a=" + accountId + " u=" + userId + " t=" + tierName + " c=" + computerId + " e=" + activityId + ((activityId === -1) ? " " + activity : "");

        if (typeof data === "object") {
            logString += " x=\"";
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    if (data[key]) {
                        var attrValue = data[key].toString();
                        logString += attrValue + " ";
                    }
                }
            }
            logString += "\"";
        }

        logString = " " + logString + " ";

        try {
            if (LE.to("activity") && logString !== "") {
                LE.to("activity").log(logString);
            }
        } catch (e) {

        }
    }
}

var activityTypes = [
    [1, "Contact Us Popup Click"],

    [100, "Login Click"],
    [101, "Logout Click"],
    [102, "Two Factor Auth Login Click"],
    [103, "User Access Denied"],
    
    [200, "Account Upgrade Click"],
    [201, "Account Close Cancel Subscription Click"],
    [202, "Account Update Card Details Cancel Click"],
    [203, "Account Change Number of Computers Cancel Click"],
    [204, "Account Confirm Cancel Subscription Click"],
    [205, "Account Update Card Details Save Click"],
    [206, "Account Change Number of Computers Save Click"],
    [207, "Upgrade Payment Type Card Click"],
    [208, "Upgrade Payment Type Paypal Click"],
    [209, "Account Confirm Upgrade Click"],
    [210, "Account Subscription Self Declaration Required"],
    [211, "Account Cancel Upgrade Click"],
    [212, "Account Security 2FA Save Click"],
    [213, "Account Update Card Details Click"],
    [214, "Account Change Number of Computers Click"],
    [215, "Account Cancel Subscription Click"],
    [216, "Paypal Payment Authorisation Complete"],
    [217, "Paypal Payment Cancelled"],
    [218, "Paypal Payment Not Supported"],
    [219, "Expired Trial to Free Click"],
    [220, "Get Computers For Trial End"],
    [221, "Trial Survey Submit Click"],
    [222, "Account Settings Tab Click"],
    [223, "Account Subscription Tab Click"],
    [224, "Account Invoices Tab Click"],
    [225, "Account Security Tab Click"],
    [226, "Account Subscription Contact Sales Click"],
    [227, "Account Subscription Add Computers Contact Sales Click"],

    [300, "Account Activation Error Contact Support Click"],
    [380, "Expired Trial Expiry Contact Us Click"],

    [400, "Help Center All Topics Displayed"],
    [401, "Help Center Topic Displayed"],

    [1000, "My Computers Events Tab Click"],
    [1001, "My Computers Reports Tab Click"],
    [1002, "My Computers Computers Tab Click"],
    [1003, "My Computers Show View Settings Click"],
    [1004, "My Computers Cancel View Settings Click"],
    [1005, "My Computers Save View Settings Click"],
    [1006, "My Computers Add Group Popup Click"],
    [1007, "My Computers Add Group Save Click"],
    [1008, "My Computers Add Group Cancel Click"],
    [1009, "My Computers Move Computers Popup Click"],
    [1010, "My Computers Batch CCleaner Popup Click"],
    [1011, "My Computers Batch Defraggler Popup Click"],
    [1012, "My Computers Batch Copy Settings Popup Click"],
    [1013, "My Computers Batch Add Software Popup Click"],
    [1014, "My Computers Move Computers Save Click"],
    [1015, "My Computers Move Computers Cancel Click"],
    [1016, "My Computers Cancel Defraggler Optimize Click"],
    [1017, "My Computers Add Computer Click"],

    [1200, "CCleaner Batch Analyze Click"],
    [1201, "CCleaner Batch Clean Click"],
    [1202, "CCleaner Batch Popup Cancel Click"],
    [1203, "Defraggler Batch Analyze Click"],
    [1204, "Defraggler Batch Defrag Click"],
    [1205, "Defraggler Batch Popup Cancel Click"],
    [1206, "Add Software Batch Click"],
    [1207, "Add Software Batch Popup Cancel Click"],
    [1208, "Copy Settings Batch Popup Copy Click"],
    [1209, "Copy Settings Batch Popup Cancel Click"],

    [1400, "Reports PDF Operating System Summary Report Generate Click"],
    [1401, "Reports HTML Operating System Summary Report Generate Click"],
    [1402, "Reports CSV Operating System Summary Report Generate Click"],
    [1403, "Reports PDF Network Summary Report Generate Click"],
    [1404, "Reports HTML Network Summary Report Generate Click"],
    [1405, "Reports CSV Network Summary Report Generate Click"],
    [1406, "Reports PDF Security Summary Report Generate Click"],
    [1407, "Reports HTML Security Summary Report Generate Click"],
    [1408, "Reports CSV Security Summary Report Generate Click"],
    [1409, "Reports View Settings Click"],
    [1410, "Reports Save View Settings Click"],
    [1411, "Reports Generate Report Click"],
    [1412, "Reports Cancel View Settings Click"],

    [1600, "Download EXE Installer Click"],
    [1601, "Download Paired Installer Click"],
    [1602, "Download Paired Installer Options Click"],
    [1603, "Download Now Paired Installer Click"],
    [1604, "Email Paired Installer Click"],

    [1700, "Trial Get Computers For Trial Start"],
    [1701, "Trial Download First Installer Click"],
    [1702, "Trial Poll For First Computer"],
    [1703, "Trial Confirm Computer Click"],
    [1704, "Trial Get Started Click"],
    [1705, "Trial Contact Support Click"],
    [1706, "Trial Create Custom Installer Click"],

    [2000, "Computer Navigate Summary"],
    [2001, "Computer Navigate Hardware"],
    [2002, "Computer Navigate Hardware CPU"],
    [2003, "Computer Navigate Hardware RAM"],
    [2004, "Computer Navigate Hardware Motherboard"],
    [2005, "Computer Navigate Hardware Graphics"],
    [2006, "Computer Navigate Hardware Hard Drives"],
    [2007, "Computer Navigate Hardware Optical Drives"],
    [2008, "Computer Navigate Hardware Audio"],
    [2009, "Computer Navigate Hardware Peripherals"],
    [2010, "Computer Navigate Hardware Network"],
    [2011, "Computer Navigate Software"],
    [2012, "Computer Navigate Software Operating System"],
    [2013, "Computer Navigate Software Processes"],
    [2014, "Computer Navigate Software Startup"],
    [2015, "Computer Navigate Software Installed Software"],
    [2016, "Computer Navigate Software Add Software"],
    [2017, "Computer Navigate Software Windows Update"],
    [2018, "Computer Navigate CCleaner"],
    [2019, "Computer Navigate CCleaner Registry"],
    [2020, "Computer Navigate CCleaner Tools"],
    [2021, "Computer Navigate CCleaner Tools Restore"],
    [2022, "Computer Navigate CCleaner Tools Wiper"],
    [2023, "Computer Navigate CCleaner Options"],
    [2024, "Computer Navigate CCleaner Options Settings"],
    [2025, "Computer Navigate CCleaner Options Cookies"],
    [2026, "Computer Navigate CCleaner Options Include"],
    [2027, "Computer Navigate CCleaner Options Exclude"],
    [2028, "Computer Navigate CCleaner Options Users"],
    [2029, "Computer Navigate Defraggler"],
    [2030, "Computer Navigate Tools"],
    [2031, "Computer Navigate Tools Network"],
    [2032, "Computer Navigate Tools Shutdown"],
    [2033, "Computer Navigate Options"],
    [2034, "Computer Navigate Options Agent"],
    [2035, "Computer Navigate Options Events"],
    [2036, "Computer Navigate Options Scheduling"],
    [2037, "Computer Navigate Options Scheduling CCleaner"],
    [2038, "Computer Navigate Options Scheduling Defraggler"],
    [2039, "Computer Navigate Events"],

    [2100, "Computer Summary Events Refresh Click"],
    [2101, "Computer Summary Disk Space Refresh Click"],

    [2200, "CCleaner Results"],
    [2201, "CCleaner Results Cancelled"],
    [2202, "CCleaner View Detailed Results Click"],
    [2203, "CCleaner Analyze Rule Click"],
    [2204, "CCleaner Analyze Click"],
    [2205, "CCleaner Clean Click"],
    [2206, "CCleaner Clean Rule Click"],
    [2207, "CCleaner Clear Click"],
    [2208, "CCleaner Cancel Analyze Click"],
    [2209, "CCleaner Cancel Clean Click"],
    [2210, "CCleaner Scan Registry Rule Click"],
    [2211, "CCleaner Scan Registry Click"],
    [2212, "CCleaner Fix Registry Click"],
    [2213, "CCleaner Clear Registry Click"],
    [2214, "CCleaner Cancel Scan Registry Click"],
    [2215, "CCleaner Cancel Fix Registry Click"],
    [2216, "CCleaner Refresh System Restore Click"],
    [2217, "CCleaner Cancel Refresh System Restore Click"],
    [2218, "CCleaner Remove System Restore Point Click"],
    [2219, "CCleaner Drive Wipe Click"],
    [2220, "CCleaner Cancel Drive Wipe Click"],
    [2221, "CCleaner Scan Registry Results Cancelled"],
    [2222, "CCleaner Fix Registry Results Cancelled"],
    [2223, "CCleaner Cookies Load Click"],
    [2224, "CCleaner Delete Cookie Click"],
    [2225, "CCleaner Add Cookie Click"],
    [2226, "CCleaner Add Include Click"],
    [2227, "CCleaner Add Exclude Click"],
    [2228, "CCleaner Settings Save Click"],
    [2229, "CCleaner Save Users Click"],
    [2230, "CCleaner Schedule Enabled"],
    [2231, "CCleaner Add Exclude File"],
    [2232, "CCleaner Add Exclude Registry"],
    [2233, "CCleaner Restore Defaults For Windows"],
    [2234, "CCleaner Restore Defaults For Applications"],
    [2235, "CCleaner Restore Defaults For Group"],
    [2236, "CCleaner Restore Defaults For Rule"],
    [2237, "CCleaner Restore Defaults For Registry"],
    [2238, "CCleaner Restore Defaults For Registry Rule"],
    [2239, "CCleaner Restore Defaults Settings"],
    [2240, "CCleaner Analyze Rule Group Click"],
    [2241, "CCleaner Clean Rule Group Click"],
    [2242, "CCleaner Save Include Click"],
    [2243, "CCleaner Save Exclude Click"],

    [2400, "Defraggler Show Files Click"],
    [2401, "Defraggler Analyze Click"],
    [2402, "Defraggler Defrag Click"],
    [2403, "Defraggler Quick Defrag Click"],
    [2404, "Defraggler Freespace Defrag Click"],
    [2406, "Defraggler Build File List Click"],
    [2408, "Defraggler Selected Files Defrag Click"],
    [2411, "Defraggler Unknown Click"],
    [2413, "Defraggler Cancel Analyze Click"],
    [2414, "Defraggler Cancel Defrag Click"],
    [2415, "Defraggler Cancel Quick Defrag Click"],
    [2416, "Defraggler Cancel Freespace Defrag Click"],
    [2418, "Defraggler Cancel Build File List Click"],
    [2420, "Defraggler Cancel Selected File Defrag Click"],
    [2423, "Defraggler Cancel Unknown Click"],
    [2425, "Defraggler Analyze Results"],
    [2426, "Defraggler Defrag Results"],
    [2427, "Defraggler Quick Defrag Results"],
    [2428, "Defraggler Freespace Defrag Results"],
    [2430, "Defraggler Build File List Results"],
    [2432, "Defraggler Selected Files Defrag Results"],
    [2435, "Defraggler Unknown Results"],
    [2437, "Defraggler Schedule Enabled"],
    [2438, "Defraggler Optimize Click"],
    [2439, "Defraggler Quick Optimize Click"],
    [2440, "Defraggler Cancel Optimize Click"],
    [2441, "Defraggler Cancel Quick Optimize Click"],
    [2442, "Defraggler Optimize Results"],
    [2443, "Defraggler Quick Optimize Results"],

    [2600, "Add Software Install Click"],
    [2601, "Add Software Dropbox Install Click"],
    [2602, "Windows Updates Refresh Click Results"],
    [2603, "Windows Updates Refresh Click"],
    [2604, "Windows Updates Install Click"],
    [2605, "Windows Updates Install Cancel Click"],
    [2606, "Windows Updates Install Click Results"],
    [2607, "Windows Updates Hide Click"],
    [2608, "Windows Updates Unhide Click"],
    [2609, "Terminate Process Click"],

    [2800, "Run network command Click"],
    [2801, "Run shutdown command Click"],
    [2802, "Cancel network command Click"],
    [2803, "Cancel shutdown command Click"],

    [2900, "Events Refresh Click"],

    [3000, "Options Events Refresh Click"],
    [3001, "Options Events Save Click"],
    [3002, "Options Events Restore Defaults Click"],

    [3100, "Options Scheduling Refresh Click"],
    [3101, "Options CCleaner Schedule Save Click"],
    [3102, "Options Defraggler Schedule Save Click"]
];